import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Footer() {
  return <footer className="bg-white border-t border-zinc-200 py-12" data-id="element-57">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-58">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6 mb-8" data-id="element-59">
          <div className="flex items-center gap-2" data-id="element-60">
            <span className="text-2xl font-bold tracking-tight text-zinc-900" data-id="element-61">
              People<span className="text-peoplecall" data-id="element-62">call</span>
            </span>
          </div>

          <nav className="flex flex-wrap justify-center gap-6 text-sm font-medium text-zinc-600" data-id="element-63">
            <a href="#" className="hover:text-zinc-900 transition-colors" data-id="element-64">
              Product
            </a>
            <a href="#" className="hover:text-zinc-900 transition-colors" data-id="element-65">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-zinc-900 transition-colors" data-id="element-66">
              Legal Notice
            </a>
            <a href="#" className="hover:text-zinc-900 transition-colors" data-id="element-67">
              Contact
            </a>
          </nav>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 pt-8 border-t border-zinc-200 text-sm text-zinc-500" data-id="element-68">
          <p data-id="element-69">© 2025 Peoplecall. All rights reserved.</p>

          <div className="flex items-center gap-2 bg-zinc-50 px-3 py-1.5 rounded-full border border-zinc-200" data-id="element-70">
            <ShieldCheck className="w-4 h-4 text-peoplecall" data-id="element-71" />
            <span className="font-medium text-zinc-700" data-id="element-72">
              Powered by CloudSurgard
            </span>
          </div>
        </div>
      </div>
    </footer>;
}